import { Input, Select, Space,Form } from 'antd';
import React from 'react';
const options = [
  {
    value: '&',
    label: '&',
  },
  {
    value: '/',
    label: '/',
  },
];

const TypSignature = (props:{width:number, widthCode:number|string ,Dissebled?:boolean}) => (

  <Form.Item
    preserve={true}
        label="Type de Signature"
        rules={[{ required:false, message: '!' }]}
        labelCol={{ span:props.width}}
        style={{width:'100%' }}  
        >
   <Space direction="vertical" >
    <Space.Compact size='middle' block style={{ gap: 0 }}>
        <Form.Item
        name="Sign1"
        rules={[{ required:false, message: '!' }]}
        labelCol={{span:100}}
       style={{ width: props.widthCode, marginBottom: 0 }}
        >
         <Input disabled  />
        </Form.Item>
        <Form.Item
        name="TSign1"
        rules={[{ required:false, message: '!' }]}
        style={{ width: '6%', marginBottom: 0 }}
        initialValue={"/"}
        >
      <Select disabled={props.Dissebled}   options={options}  />
        </Form.Item>

        <Form.Item
        name="Sign2"
        rules={[{ required:false, message: '!' }]}
        style={{ width: props.widthCode, marginBottom: 0 }}
        >
       <Input disabled  />
        </Form.Item>

        <Form.Item
        name="TSign2"
        rules={[{ required:false, message: '!' }]}
        style={{ width: '6%', marginBottom: 0 }}
        initialValue={"/"}
        >
       <Select disabled={props.Dissebled}   options={options}  />
        </Form.Item>
        <Form.Item
        name="Sign3"
        rules={[{ required:false, message: '!' }]}
        style={{ width: props.widthCode, marginBottom: 0 }}
        >
        <Input disabled defaultValue="" />
        </Form.Item>

        <Form.Item
        name="TSign3"
        rules={[{ required:false, message: '!' }]}
        style={{ width: '6%', marginBottom: 0 }}
        initialValue={"/"}
        >
       <Select  disabled={props.Dissebled}  options={options} />
        </Form.Item>
        <Form.Item
        name="Sign4"
        rules={[{ required:false, message: '!' }]}
       style={{ width: props.widthCode, marginBottom: 0 }}
        >
       <Input disabled defaultValue="" />
        </Form.Item>
        <Form.Item
        name="TSign4"
        rules={[{ required:false, message: '!' }]}
        style={{ width: '6%', marginBottom: 0 }}
        initialValue={"/"}
        >
       <Select  disabled={props.Dissebled}  options={options}  />
        </Form.Item>
        <Form.Item
        name="Sign5"
        rules={[{ required:false, message: '!' }]}
       style={{ width: props.widthCode, marginBottom: 0 }}
        >
      <Input disabled defaultValue="" />
        </Form.Item>
        
    </Space.Compact>
  </Space>

  </Form.Item> 
);

export default TypSignature;